module.exports = __webpack_public_path__ + "img/headphones.8f3d6520.png";